export default __webpack_public_path__ + "static/media/logo-white.32c7aa21.png";